(function($) {
    // Grab src from data atribute on button
    // var videoSrc;

    $('.js-modal-trigger').each(function () {
        let videoSrc = $(this).attr('data-src');

        $($(this).data('bs-target')).attr('data-video-src', videoSrc);
    });

    $('.js-modal-trigger').on('click', function(e) {
        e.preventDefault();
    });

    // Autoplay video when modal opens
    $('.popup-vimeo-modal').on('shown.bs.modal', function(e) {
        let videoSrc = $(this).data('video-src');
        if(videoSrc) {
            $(this).find('iframe').attr('src', videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
        } else {
            // if($(this).find('iframe').length) {
            //     let videoIframe = $(this).find('iframe'),
            //         videoSrc = videoIframe.attr('src');
            //     videoIframe.data('original-src', videoSrc);
            // }
        }
    });

    // Stop playing play video when modal closes
    $('.popup-vimeo-modal').on('hide.bs.modal', function(e) {
        if($(this).data('video-src') && $(this).data('video-src').length) {
            $(this).find('iframe').attr('src', '');
        } else {
            $(this).find('iframe').attr('src', $(this).find('iframe').attr('src'));
        }
    });


    // Adjust padding when show modal click - restricting from inline styling on body and site-header
    $('.js-show-modal').on('click', function(){
        let body = $('body').height();
        let width = $('body').width();
        let modal_selector = $('.modal-open');
        let header_selector = $('.site-header');
        if ( width < body) {
            modal_selector.css({'padding-right' :'0px', 'overflow' : 'hidden'});
        } else {
            modal_selector.css({
                'padding-right' : 'inherit',
                'overflow' : 'auto',
            });
            header_selector.css({
                'padding-right' : '0px'
            });
        }
    });


})(jQuery);
